<dx-popup
    #popupComponent
    class="popup"
    [width]="360"
    [height]="'auto'"
    [showTitle]="true"
    [title]="'Electronic Signature'"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [(visible)]="popupVisible">

    <dxi-toolbar-item location="after">
        <dx-button text="Sign" [disabled]="password === undefined || password === null || password === ''"
                   (click)="sign()"></dx-button>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <form style="padding-bottom: 8px">

            <div fxLayout="column" fxLayoutAlign="start center ">

                <div class="dx-field">
                    <div class="dx-field-label">User</div>
                    <div class="dx-field-value">
                        <dx-text-box [disabled]="true" [value]="username"></dx-text-box>
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Password</div>
                    <div class="dx-field-value">
                        <dx-text-box mode="password" [(value)]="password"
                                     [inputAttr]="{autocomplete: 'new-password'}" (onContentReady)="ready($event)"></dx-text-box>
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Signature's Image</div>
                    <div class="dx-field-value">
                        <img [src]="image" alt="signature" class="signature">
                    </div>
                </div>
                <input type="file" style="display: none" (change)="onFileChanged($event)" #fileInput accept="image/*"/>
                <dx-button text="Change it" (click)="fileInput.click()"></dx-button>
            </div>

        </form>
    </div>

</dx-popup>

